{
  "schemaVersion": 1,
  "id": "oak-board-20",
  "version": "1.0",
  "kind": "board",
  "species": "Oak",
  "material": "Solid oak",
  "nominalDescription": "Solid European oak 20 mm, planed all round, oiled",
  "edgeDescription": "Solid oak, planed, 1 mm arris",
  "thicknessTicks": 200,
  "nominalThicknessTicks": 200,
  "maxWidthTicks": 1800,
  "maxLengthTicks": 25000,
  "grainAxis": "length",
  "finishSpec": "Hard-wax oil, two coats",
  "density": 720,
  "back": {
    "description": "Oak-veneered plywood 6 mm, B/BB",
    "thicknessTicks": 60,
    "nominalThicknessTicks": 60,
    "sheet": { "lengthTicks": 24400, "widthTicks": 12200 },
    "grainAxis": "length",
    "allowRotation": false
  },
  "notes": "Self-authored board stock: planed oak is commonly stocked at 20 mm in widths up to 180 mm; wider parts are edge-glued from strips (plan §5). Density ≈ 720 kg/m³."
}
